var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-task-status-circle",class:[_vm.statusClasses, _vm.smallCircle === true ? 'c-task-status-circle--small' : '']},[(_vm.progressStatus === 300)?_c('i'):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }